/**
 * useSelections Hook
 * 
 * Manages selections state for the Sales component.
 * Handles getting and setting selections from pedidos.
 */

import { useState, useEffect } from 'react';

interface UseSelectionsProps {
  pedidos: any[];
  selectedPedido?: any;
  isPedidosMode: boolean;
}

interface UseSelectionsReturn {
  selections: any[];
  setSelections: React.Dispatch<React.SetStateAction<any[]>>;
  peopleNumber: number | null;
  setPeopleNumber: React.Dispatch<React.SetStateAction<number | null>>;
}

/**
 * Custom hook to manage selections state
 * Automatically syncs selections with pedidos and handles peopleNumber
 */
export const useSelections = ({ 
  pedidos, 
  selectedPedido, 
  isPedidosMode 
}: UseSelectionsProps): UseSelectionsReturn => {
  const [selections, setSelections] = useState<any[]>([]);
  const [peopleNumber, setPeopleNumber] = useState<number | null>(5);

  // Auto-set peopleNumber from first selection
  useEffect(() => {
    if (selections.length !== 0) {
      const pnum = selections[0]?.totalPersons ?? 1;
      setPeopleNumber(pnum);
    }
  }, [selections]);

  return {
    selections,
    setSelections,
    peopleNumber,
    setPeopleNumber,
  };
};
